import { render } from "./NotificationSkeleton.vue?vue&type=template&id=c76ae4e0&scoped=true"
const script = {}

import "./NotificationSkeleton.vue?vue&type=style&index=0&id=c76ae4e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c76ae4e0"]])

export default __exports__